export default "__VITE_ASSET__CWkTHHz$__"